import { compose } from 'recompose';

import ButtonView from './ButtonView';

export default compose()(ButtonView);
